// extracted by mini-css-extract-plugin
export default {"container":"TicketMain_container__NMLSw","ticket":"TicketMain_ticket__kAP8g","button-container":"TicketMain_button-container__9FGjh"};